import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "../components/auth/ProtectedRoute";
import GuestRoute from "../components/auth/GuestRoute";

import Layout from "../components/layout/Layout";
import ControlPanelGuard from "../components/auth/ControlPanelGuard";
import SubscriptionGate from "../components/auth/SubscriptionGate";
import SsdiLayout from "../components/layout/SsdiLayout";
import BankLayout from "../components/layout/BankLayout";
import PublicPageShell from "../components/layout/PublicPageShell";

import Login from "../pages/auth/Login";
import SsdiLogin from "../pages/auth/SsdiLogin";
import RepoAdminLogin from "../pages/auth/RepoAdminLogin";
import RepoAgentLogin from "../pages/auth/RepoAgentLogin";
import ForgotPassword from "../pages/auth/ForgotPassword";
import ApkRegisterHub from "../pages/auth/ApkRegisterHub";
import RegisterCompany from "../pages/auth/RegisterCompany";
import AgentRegister from "../pages/auth/AgentRegister";

import ProductsPage from "../pages/marketing/ProductsPage";
import PlansPage from "../pages/marketing/PlansPage";
import FaqsPage from "../pages/marketing/FaqsPage";
import AboutPage from "../pages/marketing/AboutPage";
import ServicesPage from "../pages/marketing/ServicesPage";
import ContactPage from "../pages/marketing/ContactPage";
import TermsPage from "../pages/marketing/TermsPage";
import PrivacyPolicyPage from "../pages/marketing/PrivacyPolicyPage";
import RefundPolicyPage from "../pages/marketing/RefundPolicyPage";
import AccountDeletionPage from "../pages/marketing/AccountDeletionPage";

import Home from "../pages/repo/dashboard/Home";
import FindVehicles from "../pages/repo/vehicles/FindVehicles";
import FindVehiclesResults from "../pages/repo/vehicles/FindVehiclesResults";
import VehicleTrace from "../pages/repo/vehicles/VehicleTrace";
import Reports from "../pages/repo/reports/Reports";
import ConfirmedCasesReport from "../pages/repo/reports/ConfirmedCasesReport";
import Users from "../pages/repo/users/Users";
import CreateUser from "../pages/repo/users/CreateUser";
import UserDetails from "../pages/repo/users/UserDetails";
import MyProfile from "../pages/repo/profile/MyProfile";
import IdCard from "../pages/repo/profile/IdCard";
import MedicineManagement from "../pages/repo/medicines/MedicineManagement";
import SalesmanManagement from "../pages/repo/salesmen/SalesmanManagement";
import ControlPanel from "../pages/repo/controlPanel/ControlPanel";
import RolesPermissions from "../pages/repo/roles/RolesPermissions";
import EmailConfiguration from "../pages/repo/emailConfig/EmailConfiguration";
import OTPs from "../pages/repo/otps/OTPs";
import DetailsView from "../pages/repo/details/DetailsView";
import Blacklist from "../pages/repo/blacklist/Blacklist";
import Confirmation from "../pages/repo/confirmation/Confirmation";
import ConfirmationVehicleRequests from "../pages/repo/confirmation/ConfirmationVehicleRequests";
import ConfirmationView from "../pages/repo/confirmation/ConfirmationView";
import InventoryUpdate from "../pages/repo/inventory/InventoryUpdate";
import RepoAgentsBills from "../pages/repo/agentBills/RepoAgentsBills";
import AgentRepoPayment from "../pages/repo/agentBills/AgentRepoPayment";
import Feedback from "../pages/repo/feedback/Feedback";
import CleanFile from "../pages/repo/cleanFile/CleanFile";
import RepoPlans from "../pages/repo/plans/RepoPlans";
import CasesList from "../pages/repo/cases/CasesList";
import LiveTracking from "../pages/repo/tracking/LiveTracking";
import FieldMap from "../pages/repo/tracking/FieldMap";

import SsdiDashboard from "../pages/ssdi/dashboard/SsdiDashboard";
import SsdiCompanies from "../pages/ssdi/companies/SsdiCompanies";
import SsdiCreateCompany from "../pages/ssdi/companies/SsdiCreateCompany";
import SsdiCompanyDetails from "../pages/ssdi/companies/SsdiCompanyDetails";
import SsdiRegistrations from "../pages/ssdi/registrations/SsdiRegistrations";
import SsdiPlans from "../pages/ssdi/plans/SsdiPlans";
import SsdiPayments from "../pages/ssdi/payments/SsdiPayments";
import SsdiOTPs from "../pages/ssdi/otps/SsdiOTPs";
import SsdiBlacklist from "../pages/ssdi/blacklist/SsdiBlacklist";
import SsdiConfirmations from "../pages/ssdi/confirmations/SsdiConfirmations";
import SsdiFeedbacks from "../pages/ssdi/feedbacks/SsdiFeedbacks";
import SsdiBanks from "../pages/ssdi/banks/SsdiBanks";
import SsdiCreateBank from "../pages/ssdi/banks/SsdiCreateBank";
import SsdiBankDetails from "../pages/ssdi/banks/SsdiBankDetails";
import SsdiUploadParkingYard from "../pages/ssdi/parkingYards/SsdiUploadParkingYard";
import SsdiUploadRepoAgencies from "../pages/ssdi/directoryUploads/SsdiUploadRepoAgencies";
import SsdiUploadCraneServices from "../pages/ssdi/directoryUploads/SsdiUploadCraneServices";
import CodeBankNbfc from "../pages/repo/codeBankNbfc/CodeBankNbfc";

import BankLogin from "../pages/bank/auth/BankLogin";
import BankRegister from "../pages/bank/auth/BankRegister";
import BankDashboard from "../pages/bank/dashboard/BankDashboard";
import BankPersons from "../pages/bank/persons/BankPersons";
import BankRecords from "../pages/bank/records/BankRecords";
import BankUploadFiles from "../pages/bank/files/BankUploadFiles";
import BankTracing from "../pages/bank/tracing/BankTracing";
import BankTraceCases from "../pages/bank/traceCases/BankTraceCases";
import BankTraceCaseDetail from "../pages/bank/traceCases/BankTraceCaseDetail";
import BankOtps from "../pages/bank/otps/BankOtps";
import BankVehicleSearch from "../pages/bank/vehicleSearch/BankVehicleSearch";
import BankProfile from "../pages/bank/profile/BankProfile";

import NotFoundPage from "../pages/shared/NotFoundPage";
import Unauthorized from "../pages/shared/Unauthorized";
export default function AppRoutes() {
  return (
    <Routes>
      <Route element={<PublicPageShell />}>
        <Route element={<GuestRoute />}>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/ssdi/login" element={<SsdiLogin />} />
          <Route path="/repo-admin/login" element={<RepoAdminLogin />} />
          <Route path="/repo-agent/login" element={<RepoAgentLogin />} />
          <Route path="/bank/login" element={<BankLogin />} />
        </Route>
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/bank/forgot-password" element={<ForgotPassword />} />
        <Route path="/register" element={<ApkRegisterHub />} />
        <Route path="/register-company" element={<RegisterCompany />} />
        <Route path="/agent-register" element={<AgentRegister />} />
        <Route path="/bank/register" element={<BankRegister />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/faqs" element={<FaqsPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/pricing" element={<PlansPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/refund-policy" element={<RefundPolicyPage />} />
        <Route path="/delete-account" element={<AccountDeletionPage />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
      </Route>
      <Route
        element={
          <ProtectedRoute
            allowedRoles={[
              "REPO_ADMIN",
              "TEAM_LEADER",
              "HEAD_OFFICE_STAFF",
              "OFFICE_STAFF",
              "REPO_STAFF",
              "REPO_VIEWER",
            ]}
          />
        }
      >
        <Route element={<Layout />}>
          <Route element={<SubscriptionGate />}>
          <Route element={<ControlPanelGuard />}>
            <Route path="/home" element={<ProtectedRoute requiredPermission="home.view" />}><Route index element={<Home />} /></Route>
            <Route path="/control-panel" element={<ProtectedRoute requiredPermission="control_panel.view" />}><Route index element={<ControlPanel />} /></Route>
            <Route path="/cases" element={<ProtectedRoute requiredPermission="cases.view" />}><Route index element={<CasesList />} /></Route>
            <Route path="/live-tracking" element={<ProtectedRoute requiredPermission="live_tracking.view" />}><Route index element={<LiveTracking />} /></Route>
            <Route path="/field-map" element={<ProtectedRoute requiredPermission="field_map.view" />}><Route index element={<FieldMap />} /></Route>
            <Route path="/find-vehicles" element={<ProtectedRoute requiredPermission="find_vehicles.view" />}><Route index element={<FindVehicles />} /><Route path="results" element={<FindVehiclesResults />} /></Route>
            <Route path="/vehicle-trace" element={<ProtectedRoute requiredPermission="find_vehicles.view" />}><Route index element={<VehicleTrace />} /></Route>
            <Route path="/reports" element={<ProtectedRoute requiredPermission="reports.view" />}><Route index element={<Reports />} />
            <Route path="/reports/confirmed-cases" element={<ConfirmedCasesReport />} />
            <Route
              path="/reports/inventory-uploaded"
              element={<Navigate to="/reports/confirmed-cases" replace />}
            /></Route>
            <Route path="/users" element={<ProtectedRoute requiredPermission="users.view" />}><Route index element={<Users />} /><Route path="create" element={<CreateUser />} /><Route path=":id" element={<UserDetails />} /></Route>
            <Route
              path="/roles-permissions"
              element={
                <ProtectedRoute
                  allowedRoles={["REPO_ADMIN"]}
                  requiredPermission="roles_permissions.manage"
                />
              }
            >
              <Route index element={<RolesPermissions />} />
            </Route>
            <Route
              path="/email-configuration"
              element={
                <ProtectedRoute
                  allowedRoles={["REPO_ADMIN"]}
                  requiredPermission="email_config.manage"
                />
              }
            >
              <Route index element={<EmailConfiguration />} />
            </Route>
            <Route path="/profile" element={<ProtectedRoute requiredPermission="profile.view" />}><Route index element={<MyProfile />} /></Route>
            <Route path="/id-card" element={<ProtectedRoute requiredPermission="id_card.view" />}><Route index element={<IdCard />} /></Route>
            <Route path="/bank-details" element={<ProtectedRoute requiredPermission={["upload_records.view", "bank_records.view"]} />}><Route index element={<MedicineManagement />} /></Route>
            <Route path="/salesman-management" element={<ProtectedRoute requiredPermission={["upload_records.view", "bank_records.view"]} />}><Route index element={<SalesmanManagement />} /></Route>
            <Route path="/bank-records" element={<Navigate to="/bank-details" replace />} />
            <Route path="/code-bank-nbfc" element={<ProtectedRoute requiredPermission="code_bank_nbfc.view" />}><Route index element={<CodeBankNbfc />} /></Route>
            <Route path="/upload-records" element={<ProtectedRoute requiredPermission="upload_records.view" />}><Route index element={<Navigate to="/bank-details" replace />} /></Route>
            <Route path="/otps" element={<ProtectedRoute requiredPermission="otps.view" />}><Route index element={<OTPs />} /></Route>
            <Route path="/details-view" element={<ProtectedRoute requiredPermission="cases.view" />}><Route index element={<DetailsView />} /></Route>
            <Route path="/blacklist" element={<ProtectedRoute requiredPermission="blacklist.view" />}><Route index element={<Blacklist />} /></Route>
            <Route path="/confirmation/vehicle/:vehicleKey" element={<ProtectedRoute requiredPermission="confirmation.view" />}><Route index element={<ConfirmationVehicleRequests />} /></Route>
            <Route path="/confirmation/:id" element={<ProtectedRoute requiredPermission="confirmation.view" />}><Route index element={<ConfirmationView />} /></Route>
            <Route path="/confirmation" element={<ProtectedRoute requiredPermission="confirmation.view" />}><Route index element={<Confirmation />} /></Route>
            <Route path="/seized-vehicles" element={<ProtectedRoute requiredPermission="confirmation.view" />}><Route index element={<Confirmation listMode="seized" />} /></Route>
            <Route path="/repo-agents-bills" element={<ProtectedRoute requiredPermission="agent_bills.view" />}><Route index element={<RepoAgentsBills />} /></Route>
            <Route path="/repo-payment" element={<ProtectedRoute requiredPermission="agent_payments.view" />}><Route index element={<AgentRepoPayment />} /></Route>
            <Route path="/inventory-update" element={<ProtectedRoute requiredPermission="inventory_update.view" />}><Route index element={<InventoryUpdate />} /></Route>
            <Route path="/feedback" element={<ProtectedRoute requiredPermission="feedback.view" />}><Route index element={<Feedback />} /></Route>
            <Route path="/clean-file" element={<ProtectedRoute requiredPermission="clean_file.view" />}><Route index element={<CleanFile />} /></Route>
            <Route path="/plans" element={<ProtectedRoute requiredPermission="plans.view" />}><Route index element={<RepoPlans />} /></Route>
          </Route>
          </Route>
        </Route>
      </Route>

      <Route
        element={<ProtectedRoute allowedRoles={["SSDI_SUPER_ADMIN"]} />}
      >
        <Route path="/ssdi" element={<SsdiLayout />}>
          <Route index element={<Navigate to="/ssdi/dashboard" replace />} />
          <Route path="dashboard" element={<SsdiDashboard />} />
          <Route path="companies" element={<SsdiCompanies />} />
          <Route path="companies/create" element={<SsdiCreateCompany />} />
          <Route path="companies/:id" element={<SsdiCompanyDetails />} />
          <Route path="registrations" element={<SsdiRegistrations />} />
          <Route path="plans" element={<SsdiPlans />} />
          <Route path="payments" element={<SsdiPayments />} />
          <Route path="otps" element={<SsdiOTPs />} />
          <Route path="blacklist" element={<SsdiBlacklist />} />
          <Route path="confirmations" element={<SsdiConfirmations />} />
          <Route path="feedbacks" element={<SsdiFeedbacks />} />
          <Route path="banks" element={<SsdiBanks />} />
          <Route path="banks/create" element={<SsdiCreateBank />} />
          <Route path="banks/:id" element={<SsdiBankDetails />} />
          <Route path="upload-parking-yard" element={<SsdiUploadParkingYard />} />
          <Route path="upload-repo-agencies" element={<SsdiUploadRepoAgencies />} />
          <Route path="upload-crane-services" element={<SsdiUploadCraneServices />} />
        </Route>
      </Route>

      {/* ── Bank Panel ── */}
      <Route
        element={<ProtectedRoute allowedRoles={["BANK_ADMIN", "BANK_PERSON"]} />}
      >
        <Route path="/bank" element={<BankLayout />}>
          <Route index element={<Navigate to="/bank/dashboard" replace />} />
          <Route path="dashboard" element={<BankDashboard />} />
          <Route path="profile" element={<BankProfile />} />
          <Route path="files" element={<BankUploadFiles />} />
          <Route path="vehicle-search" element={<BankVehicleSearch />} />
          <Route path="records" element={<BankRecords />} />
          <Route path="tracing" element={<BankTracing />} />
          <Route path="trace-cases" element={<BankTraceCases />} />
          <Route path="trace-cases/:id" element={<BankTraceCaseDetail />} />
          <Route path="seized-vehicles" element={<BankTraceCases seizedOnly />} />
          <Route path="seized-vehicles/:id" element={<BankTraceCaseDetail />} />
          <Route path="upload-parking-yard" element={<SsdiUploadParkingYard />} />
          <Route path="persons" element={<BankPersons />} />
          <Route path="otps" element={<BankOtps />} />
        </Route>
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}